import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

export default function DeleteConfirmationDialog({
  open,
  onClose,
  title,
  description,
  onConfirm,
  confirmLabel = "Delete",
  confirmDisabled = false,
  confirmButtonClassName = "bg-red-600",
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-800/50 transition-opacity"
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="max-w-lg space-y-4 border bg-white rounded-lg shadow-lg">
          <div className="p-6">
            <DialogTitle className="text-lg font-semibold mb-4">
              {title}
            </DialogTitle>
            <form>
              <p className="mb-4 text-sm text-gray-600 pb-3">{description}</p>
              <div className="flex justify-end gap-4">
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    onClose();
                  }}
                  className="px-4 py-2 rounded border"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  disabled={confirmDisabled}
                  onClick={async (e) => {
                    e.preventDefault();
                    await onConfirm();
                  }}
                  className={`px-4 py-2 text-white rounded disabled:opacity-50 disabled:cursor-not-allowed ${confirmButtonClassName}`}
                >
                  {confirmLabel}
                </button>
              </div>
            </form>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
